import { createSlice, nanoid } from '@reduxjs/toolkit';

// Reward: { id, type, value, source, icon, text, animationTarget, sound, meta }
const initialState = {
  queue: [],
};

const rewardsQueueSlice = createSlice({
  name: 'rewardsQueue',
  initialState,
  reducers: {
    enqueueReward: {
      reducer: (state, action) => {
        state.queue.push(action.payload);
      },
      prepare: (reward) => ({ payload: { id: reward.id || nanoid(), ...reward } }),
    },
    enqueueRewards: (state, action) => {
      const list = (action.payload || []).map((r) => ({ id: r.id || nanoid(), ...r }));
      state.queue.push(...list);
    },
    shiftReward: (state) => {
      state.queue.shift();
    },
    shiftMany: (state, action) => {
      state.queue.splice(0, action.payload);
    },
    clearRewards: (state) => {
      state.queue = [];
    },
  },
});

export const { enqueueReward, enqueueRewards, shiftReward, shiftMany, clearRewards } = rewardsQueueSlice.actions;
export default rewardsQueueSlice.reducer;

